<div class="modal-body p-4">
  <h5 class="modal-title">{{ title || "Bevestig" }}</h5>
  <p [innerHTML]="text || 'Ben je zeker?'"></p>

  <div class="text-end">
    <!-- confirm -->
    <app-button
      [name]="confirmText || 'Bevestigen'"
      [buttonClass]="'btn-' + confirmColor"
      (click)="activeModal.close(true)"
    ></app-button>
  </div>
</div>
